import './polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { unregister } from './serviceWorker';
import CFG, { buildCfg } from 'config'
import { getI18n } from 'services/i18n'
import { getQs } from 'services/queryString'
import { loadCache } from '@dx/i18n'

unregister();

const bootstrap = async () => {
  const lang = getQs('lang')
  await buildCfg(lang)
  if (lang && CFG.i18n) {
    const bundleI18n = await getI18n(lang)
    loadCache(bundleI18n)
    console.log('CFG builded:', CFG, bundleI18n)
  }
  ReactDOM.render(<App />, document.getElementById('root'));
}

bootstrap()

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
